import { useRouter } from "next/router";
import Script from "next/script";

import { useEffect, useMemo, useState } from "react";

import { twMerge } from "tailwind-merge";

import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";

import CustomCard from "components/CustomCard";
import FontAwesomeIcon from "components/FontAwesomeIcon";
import useAuthentication from "hooks/useAuthentication";
import useMediaQuery from "hooks/useMediaQuery";

export default function DianomiAd({ type, id, contentClassName }: any) {
  const router = useRouter();
  const { account, authenticated } = useAuthentication();
  const [show, setShow] = useState(true);
  const { mobile } = useMediaQuery();

  useEffect(() => {
    const existingScript = document.getElementById("dianomi_context_script");
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement("script");
    script.id = "dianomi_context_script";
    script.src = "https://www.dianomi.com/js/contextfeed.js";
    script.type = "text/javascript";
    document.body.appendChild(script);
  }, [router]);

  useEffect(() => {
    const handleRouteChange = () => {
      setShow(true);
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

  const content = useMemo(() => {
    if (type === "banner") {
      return (
        <iframe
          width="300"
          height="250"
          scrolling="no"
          src={
            id
              ? `https://www.dianomi.com/smartads.epl?id=${id}`
              : "https://www.dianomi.com/smartads.epl?id=42374"
          }
          style={{
            width: "300px",
            height: "250px",
            border: "none",
            overflow: "hidden",
            padding: "10px 10px 0px 10px",
          }}
        ></iframe>
      );
    } else if (type === "below_article") {
      return (
        <div className="dianomi_context" data-dianomi-context-id="4277"></div>
      );
    } else if (type === "right_sidebar") {
      return (
        <div
          className="dianomi_context min-h-[393px]"
          data-dianomi-context-id="4275"
        ></div>
      );
    } else if (type === "in_list") {
      return (
        <div
          className={twMerge(
            "dianomi_context mx-[15px] md:mx-[30px] my-[20px]",
            contentClassName
          )}
          data-dianomi-context-id="4277"
        ></div>
      );
    } else if (type === "in_list_medium") {
      return (
        <div
          className={twMerge(
            "dianomi_context mx-[15px] md:mx-[30px] my-[20px]",
            contentClassName
          )}
          data-dianomi-context-id="4276"
        ></div>
      );
    }
  }, [contentClassName, id, type]);

  if (authenticated && !account?.isPreviewPass) {
    return null;
  }

  if (mobile && type === "banner") {
    if (!show) return null;

    return (
      <CustomCard
        additionalStyle={{ padding: 0 }}
        className={"fixed !p-[5px] z-[99999] bottom-0 left-0 right-0 !mb-0 "}
      >
        <div className="w-full h-full flex items-center py-[20px] justify-center border border-inactive-gray border-solid rounded">
          <div
            className="dianomi_context w-[300px] min-h-[250px]"
            data-dianomi-context-id="4443"
          ></div>
        </div>
        <div
          className="absolute flex items-center justify-center rounded-full top-[-40px] right-[10px] w-[30px] h-[30px] bg-light-gray"
          onClick={() => setShow(false)}
        >
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </CustomCard>
    );
  }

  if (["in_list", "in_list_medium", "below_article"].includes(type)) {
    if (mobile) return null;

    return (
      <>
        {content}
        <Script
          type="text/javascript"
          id="dianomi_context_script"
          src="https://www.dianomi.com/js/contextfeed.js"
        />
      </>
    );
  }

  return (
    <>
      <CustomCard className="!p-[5px] !pt-[10px]">{content}</CustomCard>
      <Script
        type="text/javascript"
        id="dianomi_context_script"
        src="https://www.dianomi.com/js/contextfeed.js"
      />
    </>
  );
}
